import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ContainerGroupField } from '@/components/common'
import { Icons } from '@/components/icons'
import { InputControl } from '@/components/form-controls'
import type { BasicInfoFormData } from '@/types/forms/basicInfoForm'

interface NamesControlProps {
    control: Control<BasicInfoFormData>
}

export const NamesControl = ({ control }: NamesControlProps): JSX.Element => {
    const { t } = useTranslation()

    return (
        <ContainerGroupField tittleGroup={t('forms.groups.names')}>
            <div className="md:col-span-2 mb-4">
                <div className="flex items-start gap-4 p-5 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20 border-l-4 border-emerald-500 dark:border-emerald-400 rounded-lg shadow-sm">
                    <div className="bg-emerald-100 dark:bg-emerald-900/50 p-2 rounded-full flex-shrink-0 animate-pulse-subtle">
                        <Icons.Info className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-sm font-medium text-emerald-900 dark:text-emerald-100 whitespace-pre-line leading-relaxed">
                            {t('forms.groups.namesTip')}
                        </p>
                    </div>
                </div>
            </div>
            <InputControl
                name="firstName"
                maxWords={15}
                forceUppercase
                control={control}
                label={t('forms.common.firstName')}
                rules={{
                    required: t('forms.common.required.firstNameRequired')
                }}
            />

            <InputControl
                name="middleName"
                maxWords={15}
                forceUppercase
                control={control}
                label={t('forms.common.middleName')}
            />

            <InputControl
                name="firstLastName"
                forceUppercase
                maxWords={15}
                control={control}
                label={t('forms.common.firstLastName')}
                rules={{
                    required: t('forms.common.required.firstLastNameRequired')
                }}
            />
            <InputControl
                name="secondLastName"
                maxWords={15}
                forceUppercase
                control={control}
                label={t('forms.common.secondLastName')}
            />
        </ContainerGroupField>
    )
}
